import { OptionType } from "../../../../../primitives";

export const dropOptions = [
  { val: "remove", text: "remove", type: OptionType.DANGER },
];
